import { useState } from 'react';

interface DataConfig {
  limit: number;
  page: number;
  order?: 'asc' | 'desc';
  orderBy?: string;
  [key: string]: string | number | undefined;
}
function useDefaultDataConfig(additionalConfig: { [key: string]: number | string | undefined } = {}): {
  dataConfig: DataConfig;
  setDataConfig: React.Dispatch<React.SetStateAction<DataConfig>>;
} {
  const [dataConfig, setDataConfig] = useState<DataConfig>({
    limit: 10,
    page: 0,
    order: 'desc',
    orderBy: 'id',
    ...additionalConfig,
  });

  return { dataConfig, setDataConfig };
}

export type { DataConfig };
export { useDefaultDataConfig };
